import { indexData } from '@/mocks/home';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600',
  accent: 'bg-accent-100 text-accent-600',
  secondary: 'bg-secondary-100 text-secondary-600',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
            分类导览
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">
            综艺分类索引
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            按类型快速找到你想看的综艺节目
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer no-underline"
            >
              <div
                className={`w-11 h-11 rounded-xl flex items-center justify-center mb-3 ${colorMap[item.color]} transition-transform group-hover:scale-110`}
              >
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}